/* eslint-disable @typescript-eslint/no-explicit-any */

export const config = {
  httpRetry: 1,
  sessionInactivityExpirationMinutes: 60 * 3, // 3 hours
  sessionKey: "",
  apimTrace: "true",

  // BASE API
  baseApi: (window as any)?.baseApi || "http://localhost:7071/api",
  apimSubscriptionKey: (window as any)?.apimSubscriptionKey || "7858cb38da754c63a04516b200a6f73e",

  //VCDP DEV API
  // baseApi: (window as any)?.baseApi || "https://apim.dev.dignityhealthppe.org/vcapi-dev",
  // apimSubscriptionKey: (window as any)?.apimSubscriptionKey || "1e8905fb0c8b4f39bb571790e080dd0d",

  //BNI DEV API
  // baseApi: (window as any)?.baseApi || "https://apim.dev.dignityhealthppe.org/so2api",
  // apimSubscriptionKey: (window as any)?.apimSubscriptionKey || "  7858cb38da754c63a04516b200a6f73e",

  // List of site URLs that aren't authenticted by Okta and we will force
  // to a specific user.
  anonymousDomains: [
    // Uncomment this to test anonymous locally
    // {
    //   url: "https://localhost:44322",
    //   origin: "VCONSULT",
    //   // origin: "VCLINICALINFORMATICIST",
    //   apiSuffix: "api"
    // },
    {
      url: "https://virtualconsult-dev.commonspirit.org",
      origin: "VCONSULT",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualconsult-qa.commonspirit.org",
      origin: "VCONSULT",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualconsult-stg.commonspirit.org",
      origin: "VCONSULT",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualconsult.commonspirit.org",
      origin: "VCONSULT",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualci-dev.commonspirit.org",
      origin: "VCLINICALINFORMATICIST",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualci-qa.commonspirit.org",
      origin: "VCLINICALINFORMATICIST",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualci-stg.commonspirit.org",
      origin: "VCLINICALINFORMATICIST",
      apiSuffix: "virtualcare-svc"
    },
    {
      url: "https://virtualci.commonspirit.org",
      origin: "VCLINICALINFORMATICIST",
      apiSuffix: "virtualcare-svc"
    }
  ],

  // VCDP DEV APP INSIGHTS
  appInsightsKey: (window as any)?.appInsightsKey || "e7607a8b-d7b5-450f-a6a5-730fc54aef27",

  // BNI DEV APP INSIGHTS
  //appInsightsKey: (window as any)?.appInsightsKey || "30334f51-e02f-4593-bd74-bbca000a3d15",

  // AMBRA VIEWER
  ambraViewerBaseUrl:
    (window as any)?.ambraViewerBaseUrl ||
    "https://uat.dicomgrid.com/api/v3/link/external?u=e12b2ef8-fbe5-4a3f-addc-69b1b2d18f9d&v=",

  // DEVICE LOGIN SUFFIX
  deviceLoginSuffix: (window as any)?.deviceLoginSuffix || "patient-console-api",

  functionStorageAccountName:
    (window as any)?.functionStorageAccountName || "staw3vcdpfunctionsdev",

  //OKTA
  authServer:
    (window as any)?.authServer ||
    "https://loginpreview.commonspirit.org/oauth2/ausb2b0jbri7MsQGl0h7",
  oktaClientId: (window as any)?.oktaClientId || "0oazsndj073HBeByn0h7",
  oktaLoginBrand: (window as any)?.oktaLoginBrand || "CSH",
  consumerOktaEnv: (window as any)?.consumerOktaEnv || "dev",

  // This is a list of the APIM gateway URLs protected by Okta that the SPA can call.
  // It's a best practice to double check those in code within the SPA.
  oktaApiRoutes: [
    "http://localhost:7071",
    "https://apim-tst-west-us2.azure-api.net",
    "https://apim-dev-west-us2.azure-api.net",
    "https://api-dev-uw2-bni-sec2.azure-api.net",
    "https://apim.dev.dignityhealthppe.org",
    "https://apim.dignityhealth.org",
    "https://apim.dignityhealthstg.org"
  ],

  // ALLOW REGISTRATION
  allowRegistration: (window as any)?.allowRegistration || false,

  // APP COPYRIGHT
  appCopyright: (window as any)?.appCopyright || "",

  // TINYMCE
  tinyMceApiKey: "q9exm1zfydxi3cku0y1v6iwxkng5v04w2fh1sjbcz39t6r3d"
};
